export default __webpack_public_path__ + "static/media/blackcliff_longsword.522f4d19.png";